import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import css from 'css';

import ChatIcon from 'images/ChatIcon.js';

const Wrapper = styled.div`
    position: fixed;
    display: inline-block;
    background: ${css.colors.darkBlue};
    height: 40px;
    width: 40px;
    ${props => props.verticalPadding ? `bottom: ${props.verticalPadding}px;` : `20px`}
    ${props => props.horizontalPadding ? `left: ${props.horizontalPadding}px;` : `20px`}
    border-radius: 50%;
    z-index: 1001;
    cursor: pointer;

    @media(min-width: 768px) {
        height: 60px;
        width: 60px;
    }
`;

const IconWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction:column;
    min-height: 100%;
    justify-content: center;
    align-items: center;
    
    svg {
        width: 18px;
        height: 22px;

        path {
            fill: #FFF;
        }

        @media(min-width: 768px) {
            width: 28px;
            height: 32px;
        }
    }
`;

class Chat extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { appId, chat } = this.props;

        if (!appId) {
            return (null)
        }

        let w = window;
        let ic = w.Intercom;

        window.intercomSettings = {
            app_id: appId,
            alignment: 'left',
            vertical_padding: chat.verticalPadding ? chat.verticalPadding : 20,
            horizontal_padding: chat.horizontalPadding ? chat.horizontalPadding : 20,
            custom_launcher_selector: '#chat-launcher',
            hide_default_launcher: true
        };

        if (typeof ic === "function") {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
        } else {
            var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/' + appId; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); }
        }

        return (
            <Wrapper id="chat-launcher" verticalPadding={chat.verticalPadding} horizontalPadding={chat.horizontalPadding}>
                <IconWrapper>
                    <ChatIcon />
                </IconWrapper>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    chat: state.chat,
});

export default connect(mapStateToProps, {})(Chat);



// WEBPACK FOOTER //
// ./src/partials/Chat.js